import React, {useEffect, useState} from "react";
import {Card, Container, Grid, Hidden, Typography} from "@mui/material";
import styles from "../assets/css/cutomer.module.scss";
import configs from '../utils/config.json';

const Customers = (props) => {


    const [active, setActive] = useState(0);
    const duration = 5000;
    // const [items, setItems] = useState(array.slice(1));
    useEffect(() => {

    }, [active]);
    useEffect(() => {
        if (props.content.length > 0) {

            if (active === 5) {
                setActive(0);
            }
            active !== 5 && setTimeout(() => {
                if (active !== 5)
                    setActive(active + 1)
            }, duration);
        }

    }, [active, props.content]);
    // useEffect(() => {
    //     // setInterval(() => {
    //
    //     //     console.log(active + 1);
    //     //
    //     //     console.log(active);
    //     //
    //     // }, 1000);
    //     if (props.content.length > 0) {
    //         setTimeout(() => {
    //             setActive(prevState => prevState + 1);
    //         }, duration);
    //     }
    // }, [props.content]);
    // useEffect(() => {
    //     setTimeout(() => {
    //         if (active === 3) {
    //             setActive(0);
    //         } else {
    //             setActive(prevState => prevState + 1);
    //         }
    //     }, duration);
    // }, [active]);


    const setIndex = (index) => {
        // let a = items;
        // a.push(active)
        // setItems(a.slice(0, index).concat(a.slice(index + 1)));
        setActive(index);
    }

    return <div className={styles.container}>
        <Container maxWidth={"lg"}>
            <Typography variant={"h5"} className={styles.title}>
                {props.title}
            </Typography>
        </Container>
        <Container maxWidth={"xl"}>
            <Hidden mdDown>
                <Grid container>
                    <Grid item xs={2}>
                        {active === 4 ? <Item {...props.content[3]} index={3} setIndex={setIndex}/> :
                            <Item {...props.content[4]} index={4} setIndex={setIndex}/>}

                    </Grid>
                    <Grid item xs={4}>
                        <MainItem {...props.content[active]} key={"1234"}/>
                    </Grid>

                    <Grid container item xs={6}>
                        {props.content.slice(0, 4).map((item, index) => {
                            if (active === 4) {
                                if (index !== active && index !== 3)
                                    return <Grid item xs={4}>
                                        <Item {...item} index={index} setIndex={setIndex} key={index}/>
                                    </Grid>
                            } else if (index !== active)
                                return <Grid item xs={4}>
                                    <Item {...item} index={index} setIndex={setIndex} key={index}/>
                                </Grid>
                        })}

                        <Grid item xs={12}>
                            <div className={styles.dotContainer}>

                                {props.content.slice(0, 5).map((item, index) => {
                                    return <span className={`${styles.dot} ${index === active ? styles.activeDot : ''}`}
                                                 onClick={e => {
                                                     setIndex(index)
                                                 }} key={`${index}`}></span>

                                })}
                            </div>
                        </Grid>
                    </Grid>


                </Grid>
            </Hidden>
            <Hidden mdUp>
                <MainItem {...props.content[active]}/>
                <div className={styles.dotContainer}>

                    {props.content.slice(0, 5).map((item, index) => {
                        return <span className={`${styles.dot} ${index === active ? styles.activeDot : ''}`}
                                     onClick={e => {
                                         setIndex(index)
                                     }} key={`${index}`}></span>

                    })}
                </div>
            </Hidden>

        </Container>

    </div>;
};


const Item = (props) => {

    return <>
        <Card style={{margin: 15, marginTop: 80}}
              onClick={e => {
                  props.setIndex(props.index);
              }}>
            <div className={styles.itemContainer}>
                <img src={`${configs.server.Storage}/${props.img}`} className={styles.img} alt={""}/>
                <div>

                </div>
                <img src={`${configs.server.Storage}/${props.icon}`} className={styles.logo} alt={""} style={{zIndex:3}}/>

                <div className={styles.text}>
                    <Typography component={"h6"} variant={"subtitle2"}>
                        {props.name}
                    </Typography>
                    <Typography component={"p"} variant={"caption"}  style={{textAlign: "justify"}}>
                        {props.description}
                    </Typography>
                </div>
            </div>
        </Card>
    </>
}

const MainItem = (props) => {
    return <>
        <Card elevation={3} className={styles.mainItemContainer}>
            <img src={`${configs.server.Storage}/${props.icon}`} alt={""}/>
            <div className={styles.text}>
                <Typography component={"h6"} variant={"h6"}>
                    {props.name}
                </Typography>
                <Typography component={"p"} variant={"subtitle2"}  style={{textAlign: "justify"}}>
                    {props.description}
                </Typography>
            </div>
        </Card>
    </>;
}
export default Customers;